module.exports = __webpack_public_path__ + "static/media/smokey-bbq-hero-mobile.b7379357.jpg";